import React from "react";
import { getFairLeagueTable } from '../../../api/getFairLeagueTable';

import styles from "./LeagueFairTeamsTable.module.css";
import { useParams } from "react-router-dom";
import GreenCardNum from "../../../partials/GreenCardNum/GreenCardNum";

function LeagueFairTeamsTable() {
  const { leagueId } = useParams();
  const [scores, setScores] = React.useState([]);
  const [isLoading, setIsLoading] = React.useState(true);

  React.useEffect(() => {
    getFairLeagueTable(leagueId).then((data) => {
      setScores(data);
      setIsLoading(false);
    });
  }, [leagueId]);

  return (
    <div className={styles.leagueFairTable}>
      <div className="collapsBtn">קבוצות הוגנות</div>

      <div className={`${styles.tableRow} ${styles.tableTopic}`}>
        <div>-</div>
        <div>קבוצה</div>
        <div>כרטיסים ירוקים</div>
      </div>

      {isLoading ? (
        <div>הנתונים בטעינה ...</div>
      ) : (
        scores.map((score, index) => (
          <div
            key={score.id}
            className={`${styles.tableRow} ${
              index % 2 === 0 ? styles.odd : styles.even
            }`}
          >
            <div>{index + 1}</div>
            <div>{score.name}</div>
            <div>
              <div className={styles.greenCardDiv}>
                <GreenCardNum size={10} num={score.green_cards} />
              </div>
            </div>
          </div>
        ))
      )}
    </div>
  );
}

export default LeagueFairTeamsTable;
